import { dissoc } from 'ramda';

export const removePropertiesFromObjects = (propsToRemove: string[], object: {}) => {
	const tempObject = object;

	return propsToRemove.reduce((modifiedObject: any, currentProperty: any) => {
		return dissoc(currentProperty, modifiedObject);
	}, tempObject);
};
